module.exports = __webpack_public_path__ + "static/media/hp_clients.b89d6d3e.svg";